import { ApiProperty } from "@nestjs/swagger";



export class DepartmentDto {
    @ApiProperty()
    id: number;

    @ApiProperty()
    departmentName: string;

    @ApiProperty()
    hod: string;

    @ApiProperty()
    hodId: number;

    @ApiProperty()
    plantId: number;

    @ApiProperty()
    isActive: boolean;
    
    @ApiProperty()
    createdUser: string | null;

    @ApiProperty()
    createdAt: Date;

    @ApiProperty()
    updatedUser: string | null;

    @ApiProperty()
    updatedAt: Date;

    @ApiProperty()
    versionFlag: number;
}